import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BaseResponse } from "../models/base.response";
import { environment } from "../../../environments/environment";
import { TestKnowRequest, TestRequest } from "../models/test.model";

@Injectable({
    providedIn: 'root'
})
export class TestsService {

    constructor(private http: HttpClient) {
    }

    find(userId: string, typeId?: number): Observable<BaseResponse<any>> {
        let params = new HttpParams()
            .set('userId', userId);
        if (typeId)
            params = params.set('typeId', typeId);
        return this.http.get<BaseResponse<any>>(`${environment.apiUrl}/tests`, { params });
    }

    updateTest(test: TestRequest): Observable<BaseResponse<any>> {
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/tests/update`, test);
    }

    updateTestKnow(test: TestKnowRequest): Observable<BaseResponse<any>> {
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/tests/know`, test);
    }

    updatePriorityTestKnow(test: TestKnowRequest): Observable<BaseResponse<any>> {
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/tests/know/priority`, test);
    }

    getDimensions(): Observable<BaseResponse<any>> {
        return this.http.get<BaseResponse<any>>(`${environment.apiUrl}/tests/dimensions`);
    }
}